
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_20331","data-name":"Group 20331","transform":"translate(-22 -71)"}},[_c('rect',{attrs:{"id":"Rectangle_4985","data-name":"Rectangle 4985","width":"22","height":"22","rx":"5","transform":"translate(22 71)","fill":"#f4f5fd"}}),_c('g',{attrs:{"id":"Group_20456","data-name":"Group 20456","transform":"translate(-836.738 -1385.849)","fill":"none","stroke":"#5b6474","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1"}},[_c('rect',{attrs:{"id":"Rectangle_7141","data-name":"Rectangle 7141","width":"12.698","height":"11.725","rx":"2.226","transform":"translate(863.39 1462.748)"}}),_c('line',{attrs:{"id":"Line_459","data-name":"Line 459","x2":"12.698","transform":"translate(863.39 1466.013)"}}),_c('line',{attrs:{"id":"Line_460","data-name":"Line 460","y2":"2.448","transform":"translate(873.249 1461.226)"}}),_c('line',{attrs:{"id":"Line_461","data-name":"Line 461","y2":"2.448","transform":"translate(866.17 1461.226)"}})])])])
          )
        }
      }
    